import { render } from "./Nyukinyoteicreate.vue?vue&type=template&id=46a62fb0&ts=true"
import script from "./Nyukinyoteicreate.vue?vue&type=script&lang=ts"
export * from "./Nyukinyoteicreate.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__